
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
@Component({ name: 'vBackButton' })
export default class indexView extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  label!: string
  @Prop({
    type: Number,
    default: 0.938,
  })
  width!: number
  clickButton() {
    console.log(1111)

    this.$emit('clickButton')
  }
  mounted() {
    this.$nextTick(() => {
      document
        .querySelector('.backButton')
        ?.querySelector('.van-button--default')
        ?.setAttribute('style', `width:${this.width}rem`)
    })
  }
}
